import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import MaterialTypography from "../../../components/MaterialTypography";
import { Card, CardHeader, CardContent, Typography, Grid, Stack, Button, TextField } from '@mui/material';
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";

function ViewScreen_LeaveData() {
   const [employeeData,setemployeeData] = useState([])
   const navigate = useNavigate()
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        const id = queryParams.get("id")
        
        if (id) {
          getemployeedata(id)
        }
       
    }, [])


    const getemployeedata = async(id)=>{
        const query = ` query get_leave($id: String!) {
                getLeaveById(id: $id) {
                    id
                    requestedOn
                    leaveType{
                        leaveType
                    }
                    leaveFrom
                    leaveTill
                    totalDays
                    reason
                    teamApproval
                    hrApproval
                    halfDay
                    status
                    lastUpdate
                    teamleaderId
                    user{
                    firstName
                    }
                }
            }
  `
            try {
              const response = await axios.post(BASEURL, {
                query: query,
                variables: { id },
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
         
            const leaveDatass = response.data.data.getLeaveById;
            console.log('leaveDatass:',leaveDatass);
            
             setemployeeData(leaveDatass)  
            } catch (error) {
              console.log('ReponseError:',error);
              
            }
   
     }

     function formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB'); // This will return 'dd/mm/yyyy' format
      }

      const handleclose = ()=>{
        navigate('/leave-management')
      }
   
  return (
     <DashboardLayout>
     <Card sx={{ padding: 2, boxShadow: 3 }}>
       <CardHeader
         title={
           <Stack direction="column" spacing={0}>
             <Typography variant="h5" fontWeight="bold" textAlign="center">
               Leave Details
             </Typography>
           </Stack>
         }
       />
      <CardContent>
        <Grid container spacing={1} justifyContent="center">
               {/* Left Column */}
               <Grid item xs={12} sm={6}>
                 <Stack spacing={2}>
                   <Typography variant="h6">
                     <strong>User Name:</strong>{" "}
                     <span style={{ color: "#67748E" }}>
                       {employeeData.user?.firstName?.toUpperCase()}
                     </span>
                   </Typography>
                   <Typography variant="h6">
                     <strong>Leave Type:</strong>{" "}
                     <span style={{ color: "#67748E" }}>
                       {employeeData.leaveType?.leaveType}
                     </span>
                   </Typography>
                   <Typography variant="h6">
                     <strong>Leave From:</strong>{" "}
                     <span style={{ color: "#67748E" }}>{employeeData.leaveFrom}</span>
                   </Typography>
                   <Typography variant="h6">
                     <strong>Leave Till:</strong>{" "}
                     <span style={{ color: "#67748E" }}>{employeeData.leaveTill}</span>
                   </Typography>
                   <Typography variant="h6">
                     <strong>Total Days:</strong>{" "}
                     <span style={{ color: "#67748E" }}>{employeeData.totalDays}</span>
                   </Typography>
                 </Stack>
               </Grid>
       
               {/* Right Column */}
               <Grid item xs={12} sm={6}>
                 <Stack spacing={2}>
                   <Typography variant="h6">
                     <strong>Reason:</strong>{" "}
                     <span style={{ color: "#67748E" }}>{employeeData.reason}</span>
                   </Typography>
                   <Typography variant="h6">
                     <strong>Manager Approval:</strong>{" "}
                     <span style={{ color: "#67748E" }}>
                     {employeeData?.teamApproval == 'approved' ? "Approved": employeeData?.teamApproval == 'rejected'? "Rejected" : employeeData?.teamApproval }
                     </span>
                   </Typography>
                   <Typography variant="h6">
                     <strong>HR Approval:</strong>{" "}
                     <span style={{ color: "#67748E" }}>
                     {employeeData?.hrApproval == 'approved' ? "Approved": employeeData?.hrApproval == 'rejected'? "Rejected" : employeeData?.hrApproval}
                     </span>
                   </Typography>
                   <Typography variant="h6">
                     <strong>Status:</strong>{" "}
                     <span style={{ color: "#67748E" }}>  {employeeData?.status == 'approved' ? "Approved": employeeData?.status == 'rejected'? "Rejected" : employeeData?.status} </span>
                     </Typography>
                 </Stack>
               </Grid>
             </Grid>
              <Grid container spacing={2} justifyContent="center" marginTop={4}>
                  
                      <Grid item>
                           <MaterialButton
                             variant="contained"
                             color="dark"
                              onClick={() => handleclose()}
                           >
                             Close
                           </MaterialButton>
                         </Grid>
                   </Grid>
      </CardContent>
    </Card>
  </DashboardLayout>
  
  
  );
}

export default ViewScreen_LeaveData;
